module.exports = __webpack_public_path__ + "img/dejia-logo.613793c6.png";